import React from "react";
import i18n from "../../../i18n";
import { getLoggedUser } from "../../../state/user";

const user = getLoggedUser();

const tableHeaderStyle = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  padding: "0.5rem 0.5rem",
  border: "1px solid #efefef",
  fontSize: "0.8rem",
};
const tableCellStyle = {
  border: "1px solid #efefef",
  fontSize: "0.8rem",
};
class ListAucsTable extends React.Component {
  constructor() {
    super();
    this.state = {
      show_fund_screen: false,
      add: {},
      errors: {},
      selected_group: null,
      selected_auction: null,
      payment_popup: false,
      payment_approval_popup: false,
      payment: {},
      payment_approval: {
        remarks: "",
      },
      file_receipt: null,
      is_loading: false,
      fileInputs: [],
      sortByUsername: false,
      pay_auction: {},
    };
  }

  calculateTotalAmount() {
    const { auctions } = this.props;
    let totalAmount = auctions
      .filter((item) => {
        const amount = parseFloat(item?.winner?.total_amount) || 0;
        return amount;
      }, 0)
      .toFixed(2);
    return totalAmount;
  }

  render() {
    let { auctions } = this.props;
    //const totalAmount = this.calculateTotalAmount();
    if (user.role === "F") {
      auctions = [...auctions].sort(
        (a, b) => (b.withdraw_status !== "A") - (a.withdraw_status !== "A")
      );
    }

    if (this.state.sortByUsername) {
      auctions = [...auctions].sort((a, b) => {
        const usernameA = a?.winner?.username || "";
        const usernameB = b?.winner?.username || "";
        return usernameA.localeCompare(usernameB);
      });
    }

    return (
      <>
        <div
          className="rounded-3 table-responsive"
          style={{
            maxHeight: "300px",
            overflow: "scroll",
            padding: "1rem",
          }}
        >
          {/* {totalAmount} */}
          <table className="table table-stripped table-sm">
            <thead>
              <tr>
                <th style={tableHeaderStyle}>{i18n.t("sl_no")}</th>
                <th style={tableHeaderStyle}>{i18n.t("ID")}</th>
                <th style={tableHeaderStyle}>{i18n.t("auction")}</th>
                <th style={tableHeaderStyle}>{i18n.t("client")}</th>
                <th style={tableHeaderStyle}>{i18n.t("winner")}</th>
                <th style={tableHeaderStyle}>
                  {i18n.t("total_amount")}-{i18n.t("bidder")}
                </th>
              </tr>
            </thead>
            <tbody>
              {auctions.map((item, i) => (
                <tr key={item.id + Math.random()}>
                  <td style={tableCellStyle}>{i + 1}</td>
                  <td style={tableCellStyle}>{item.auction_number}</td>
                  <td style={{ ...tableCellStyle, textWrap: "nowrap" }}>
                    {item.title}
                  </td>
                  <td style={{ ...tableCellStyle, textWrap: "nowrap" }}>
                    {item?.organizationDetails?.organization_name}
                  </td>
                  <td style={tableCellStyle}>
                    {item?.winner?.name ? item?.winner?.name : "N/A"}
                  </td>
                  <td style={tableCellStyle}>
                    {item?.winner?.total_amount.toFixed(3)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  }
}

export default ListAucsTable;
